import useNodeContext from "../hooks/useNodeContext";
import AttributeBlock from "./Blocks/AttributeBlock";
import MomentsBlock from "./Blocks/MomentsBlock";
import ParameterBlock from "./Blocks/ParameterBlock";
import PredefinedFuncBlock from "./Blocks/PredefinedFuncBlock";
import ValidateInfoBlock from "./Blocks/ValidateInfoBlock";
import CreateEditConditionalNode from "./CreateEditConditionalNode";
import CreateEditResponseNode from "./CreateEditResponseNode";

export default function ConfigureSingleResponseBlockType() {
    const { state } = useNodeContext();
    return (
        <>
            {state.selectedBlockType === "attribute" ? (
                <AttributeBlock showCreateButton />
            ) : (
                <></>
            )}
            {state.selectedBlockType === "parameter" ? (
                <ParameterBlock showCreateButton />
            ) : (
                <></>
            )}
            {state.selectedBlockType === "moment" ? (
                <MomentsBlock showCreateButton />
            ) : (
                <></>
            )}
            {state.selectedBlockType === "function" ? (
                <PredefinedFuncBlock showCreateButton />
            ) : (
                <></>
            )}
            {state.selectedBlockType === "validateInfo" ? (
                <ValidateInfoBlock showCreateButton />
            ) : (
                <></>
            )}
            {state.selectedBlockType === "condition" ? (
                <CreateEditConditionalNode type="condition" />
            ) : (
                <></>
            )}
            {state.selectedBlockType === "response" ? (
                <CreateEditResponseNode />
            ) : (
                <></>
            )}
            {state.selectedBlockType === "condition_gpt" ? (
                <CreateEditConditionalNode type="condition_gpt" />
            ) : (
                <></>
            )}
        </>
    );
}
